// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__29Mvf","additionalInfo":"AgreementModal_additionalInfo__3WIbI"};